// extracted by mini-css-extract-plugin
module.exports = {"item":"IconListItem_item__0SOwj","icon":"IconListItem_icon__nwOed","content":"IconListItem_content__I3LqU","subtext":"IconListItem_subtext__AeThf"};